import { render, staticRenderFns } from "./RestaurantAmbience.vue?vue&type=template&id=a6b8b13c&scoped=true&"
import script from "./RestaurantAmbience.vue?vue&type=script&lang=ts&"
export * from "./RestaurantAmbience.vue?vue&type=script&lang=ts&"
import style0 from "./RestaurantAmbience.vue?vue&type=style&index=0&id=a6b8b13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b8b13c",
  null
  
)

export default component.exports